import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { redux } from '../reduxService';
import reportWebVitals from '../reportWebVitals';
import App from './App';
import './index.scss';
import './style/base.scss';
import { BrowserRouter } from 'react-router-dom';
// Import new unified logging system
import { logger } from './utils/logger';
// Import log configuration
import { initializeLogConfig } from '../config/logConfig';
// Import data services for eager loading
import { ProductDataService } from './services/ProductDataService';
import { DrainageDataService } from './services/DrainageDataService';

// Initialize log configuration (disable console.log in production)
initializeLogConfig();

const container = document.getElementById('root');
const root = createRoot(container!);

// Initialize unified logging system
console.log('🎯 Unified LogDebug System Initialized - Ready for filtered debugging');
console.log('📋 Usage: ?LOG_FILTER=pdf_export&enableLogCapture=true');
console.log('📊 SessionStorage access: JSON.parse(sessionStorage.getItem("debugLogs"))');

// Initialize data services before rendering to ensure synchronous access
// to product data is available when components mount
Promise.all([
    ProductDataService.ensureInitialized(),
    DrainageDataService.ensureInitialized(),
])
    .then(() => {
        console.log('✅ Data services initialized - product data loaded from API');
    })
    .catch((error) => {
        console.error('⚠️ Data services initialization failed:', error);
    })
    .finally(() => {
        root.render(
            <Provider store={redux}>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </Provider>
        );

        reportWebVitals();
    });
